<template>
  <div>
    <b-form @submit.prevent>
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="FEN"
            label-for="vi-fen"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-fen"
                v-model="puzzle.fen"
                placeholder="FEN"
                disabled="disabled"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <chessboard :fen="puzzle.fen" />
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Book ID"
            label-for="vi-book-id"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="BookIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-book-id"
                v-model="puzzle.book"
                placeholder="Book ID"
                disabled="disabled"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Chapter Number"
            label-for="vi-book-chapter"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="HashIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-book-chapter"
                v-model="puzzle.chapter"
                placeholder="Chapter number"
                disabled="disabled"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Title"
            label-for="vi-book-title"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="EditIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-book-title"
                v-model="puzzle.title"
                placeholder="Title"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Rating"
            label-for="vi-rating"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="EditIcon" />
              </b-input-group-prepend>
              <b-form-input
                id="vi-rating"
                v-model="puzzle.rating"
                placeholder="Rating"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Level"
            label-for="vi-level"
          >
            <b-input-group class="input-group-merge">
              <b-input-group-prepend is-text>
                <feather-icon icon="EditIcon" />
              </b-input-group-prepend>
              <b-form-select
                v-model="puzzle.level"
                :options="levels"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Solution"
            label-for="vi-solution"
          >
            <b-input-group class="input-group-merge">
              <b-form-textarea
                id="vi-solution"
                v-model="puzzle.solution"
                placeholder="Solution"
                rows="3"
                max-rows="6"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-checkbox
            id="samples"
            v-model="puzzle.sample"
            name="samples"
            value="true"
            unchecked-value="false"
            disabled="disabled"
          >
            Sample
          </b-form-checkbox>
          <br/>
        </b-col>
        <b-col cols="1">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mr-1"
            @click="savePuzzle"
          >
            Save
          </b-button>
        </b-col>
        <b-col cols="1">
          <div style="margin-left: 5px;margin-top: 3px">
            <b-spinner
              :style="{ display: showLoading }"
              type="grow"
            />
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
  BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BInputGroup, BInputGroupPrepend, BSpinner, BFormSelect, BFormTextarea, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { chessboard } from 'vue-chessboard'
import 'vue-chessboard/dist/vue-chessboard.css'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    BButton,
    BSpinner,
    BFormSelect,
    chessboard,
    BFormTextarea,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      puzzle: {},
      showLoading: 'none',
      levels: [
        { value: null, text: 'Please select an level' },
        { value: 'EASY', text: 'EASY' },
        { value: 'MODERATE', text: 'MODERATE' },
        { value: 'HARD', text: 'HARD' },
        { value: 'VERY_HAR', text: 'VERY_HAR' },
      ],
    }
  },
  mounted() {
    const url = `${this.$readerURL}/admin/puzzles/${this.$route.params.fen}`
    this.loader('block')
    firebase.auth().currentUser.getIdToken(false).then(idToken => {
      axios.get(url,
        {
          headers: {
            Authorization: idToken,
          },
        }).then(response => {
        this.loader('none')
        this.puzzle = response.data
        return response
      }).catch(error => {
        console.log(error)
        this.loader('none')
      })
    })
  },
  methods: {
    savePuzzle() {
      const url = `${this.$readerURL}/admin/puzzles/${this.$route.params.fen}`
      this.loader('block')
      firebase.auth().currentUser.getIdToken(false).then(idToken => {
        axios.post(url, this.puzzle,
          {
            headers: {
              Authorization: idToken,
            },
          }).then(response => {
          this.puzzle = response.data
          this.loader('none')

          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'success',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          return response
        }).catch(error => {
          this.loader('none')
          console.log(error)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'EditIcon',
              variant: 'error',
            },
          })
        })
      })
    },
  },
}
</script>
